import { SearchApi } from '@ps/api/search';
import type {
  CommunityChannelMemberSearchItem,
  CommunityChannelMemberStatusEnumItem,
} from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

export type ChannelMemberItem = CommunityChannelMemberSearchItem;

/**
 * One page of channel members. Slice 4 fetches a generous first
 * page (100) — most channels are small enough that one page is
 * the whole list. Pagination + tabs (All / Blocked) are layered on
 * top by the panel.
 */
export async function fetchChannelMembers(
  creatorId: string,
  channelId: string,
  {
    blocked,
    status,
    pageSize = 100,
    pageNo = 1,
  }: {
    blocked?: boolean;
    status?: CommunityChannelMemberStatusEnumItem;
    pageSize?: number;
    pageNo?: number;
  } = {},
): Promise<ChannelMemberItem[]> {
  const api = withClientAPI(SearchApi);
  const res = await api.searchApiControllerSearchStoreCommunityChannelMembers({
    storeId: creatorId,
    channelId,
    pageNo,
    pageSize,
    blocked,
    status,
  });
  return res.data.rows;
}
